import {
    createSelector,
} from 'reselect';

const selectCurrentGlobalBannerMessage = () => {
    return 'Winter Weather Warning... please make sure to check with your ticket provider before venturing out. Stay safe!';
};

const selectCurrentGlobalBannerType = () => {
    return 'info'; // enum
};

const selectCurrentGlobalBannerUrl = () => {
    return null;
};

const selectGlobalBannerVisible = () => {
    return false;
};

const selectGlobalBannerMessage = createSelector(
    selectCurrentGlobalBannerMessage,
    selectCurrentGlobalBannerType,
    selectCurrentGlobalBannerUrl,
    (message, type, url) => ({ message, type, url }),
);

export {
    selectGlobalBannerMessage,
    selectGlobalBannerVisible,
};
